module.exports = __webpack_public_path__ + "static/media/pt.24449c1e.svg";